import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-myaccountmenu',
  templateUrl: './myaccountmenu.component.html',
  styleUrls: ['./myaccountmenu.component.css']
})
export class MyaccountmenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
